import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { GenesisUnitOfWork } from '../../core/core.module';

@Component({
    selector: 'app-part-po-dialog',
    templateUrl: './part-po-dialog.component.html',
    styleUrls: ['./part-po-dialog.component.scss'],
    standalone: false,
})
export class PartPurchaseOrderDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    partId: number;
    orders: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    modalRef = inject(BsModalRef);
    uow = inject(GenesisUnitOfWork);
    constructor() {}

    async ngOnInit() {
        this.orders = await this.uow.getPurchaseOrderByPartId(this.partId);
        console.log(this.orders);
    }

    rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.result.next({ success: true, value: e.data.purchaseOrder.id });
    }

    async select() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData() as any;
        if (selectedRow.length === 0) return;
        this.result.next({ success: true, value: selectedRow[0].purchaseOrder.id });
    }

    close() {
        this.result.next(false);
    }
}
